<template>
  <div class="pos-fnb-container">
    <posFnBHeader :onClickHandler="onClickCall" />
    <section class="pos-fnb-center-view">
      <div class="row h-100">
        <div class="col-lg-9 col-xl-9 col-md-8 col-sm-8">
          <div v-if="FnBItemsModule" class="pos-fnb-search-wrapper">
            <form
              v-on:submit.prevent.self="fetchFnBItems"
              class="pos-fnb-searchbar"
            >
              <input
                :value="fnbSearch"
                type="text"
                id="fnb_search"
                @input="onSearchFnbItems"
                placeholder="Search for Food Items"
                class="text-black"
              />
              <input type="submit" value />
              <div
                v-if="fnbSearch.length > 0"
                style="width: 50px"
                class="pos-fnb-clearSearch text-black"
                @click="
                  setOnFnBPayloads({ event: $event, name: 'clearsearch' })
                "
              >
                &times;
              </div>
              <VkeyboardFloat
                :ID="'fnb_search'"
                :onClickFun="
                  () => {
                    Object.keys(keyboardsVisible).map(x => {
                      if (x == 'showFnbSearchKeyboard') {
                        keyboardsVisible[x] = !keyboardsVisible[x];
                      } else {
                        keyboardsVisible[x] = false;
                      }
                    });
                  }
                "
              />
              <Vkeyboard
                :inputName="'fnb_search'"
                :showOrHide="keyboardsVisible.showFnbSearchKeyboard"
                :initialValue="fnbSearch"
                @onChangeEvent="() => {}"
                @onKeyEnter="fetchFnBItems()"
                @changeKeyboardInput="
                  event => {
                    fnbSearch = event;
                    setOnFnBPayloads({
                      event: {
                        target: {
                          value: event
                        }
                      },
                      name: 'search'
                    });
                  }
                "
                @onClickClose="
                  () => {
                    keyboardsVisible.showFnbSearchKeyboard = false;
                  }
                "
              />
            </form>

            <button
              :class="[
                'btn-pos-fnb-filter ml-3 ',
                { invisible: fnbSubSubCategories.length == 0 }
              ]"
              v-b-modal.filterFnbItems
            ></button>

            <div class="d-flex align-items-center pl-3 switch-success">
              <!-- value-field -->
              <b-form-checkbox
                v-model="isVegSwitch"
                unchecked-value="N"
                button-variant="info"
                value="Y"
                name="check-button"
                @input="setOnFnBPayloads({ event: $event, name: 'isVeg' })"
                switch
              ></b-form-checkbox>
              <!-- @input="onIsVegChange({ event: $event,})" -->
              <label class="text-nowrap ml-3 mb-0 text-success">Veg Only</label>
            </div>

            <div
              v-if="isVeg === 'Y'"
              class="d-flex align-items-center pl-3 switch-warning"
            >
              <b-form-checkbox
                unchecked-value="N"
                value="Y"
                name="check-button"
                @input="setOnFnBPayloads({ event: $event, name: 'isEgg' })"
                switch
              ></b-form-checkbox>
              <label class="text-nowrap ml-3 mb-0">Contains Egg</label>
            </div>
            <!-- <button class="btn-pos-fnb-scan"></button> -->
          </div>

          <div
            :class="[FnBItemsModule ? 'pos-fnb-components-container' : null]"
          >
            <div
              v-if="isFnbDataLoading && FnBItemsModule"
              class="pos-fnb-item-not-found"
            >
              <div>
                <div>
                  <img
                    src="@/assets/img/icons/loading.svg"
                    height="75"
                    width="75"
                  />
                </div>
                <h6 class="pt-3 mb-2">Loading...</h6>
                <h6>Fetching Fnb Items...Please Wait</h6>
              </div>
            </div>

            <div v-if="!fnbItems" class="pos-fnb-item-not-found">
              <div>
                <div>
                  <img
                    src="@/assets/img/icons/pos-fnb-no-itmes.svg"
                    height="75"
                    width="75"
                  />
                </div>
                <h6 class="pt-3 mb-2">Opps!</h6>
                <h6>No Items Found!</h6>
              </div>
            </div>

            <PosFnbPopcorn v-if="FnBItemsModule" :foodItems="fnbItems || []" />
            <PosFnbCheckout v-if="!FnBItemsModule" />

            <PosFnBFinalTicket
              v-if="showFnBOrderDetails"
              :onNumberSubmit="OnPhoneNumberSubmitHandler"
              :onClickHandler="onSwtichModule"
              :itemsList="SelectedFnbItemList"
              :taxesTotal="TotalAdditionalTaxes"
              :taxes="AdditionalTaxList"
              :subTotal="selectedFnBItemsTotalPrice"
              :currency="getFnBCurrency.curr_code"
              :getloyaltyAmountNew="getloyaltyAmount"
              :onPrintCall="GoToRoute"
              :printText="printText"
            />
          </div>
        </div>

        <!-- customizable pop up -->
        <b-modal
          size="lg"
          hide-footer
          id="customization-modal"
          title="Add customization to your item"
        >
          <div>
            <div class="row text-uppercase font-weight-bold pb-2 border-bottom">
              <div :class="['align-self-center col-5']">
                <span class="px-3">Item</span>
              </div>
              <div class="col-2 align-self-center text-center">
                <!-- <span>UOM</span> -->
              </div>
              <div class="col-2 align-self-center text-center">
                <!-- <span>PRICE</span> -->
              </div>
              <div class="col-3 text-right">
                <span class="px-3">Action</span>
              </div>
            </div>
            <div class="row mx-0">
              <div
                class="col-12 py-3 border-bottom"
                :key="customizationIndex"
                v-for="(customization,
                customizationIndex) in customizationsList"
              >
                <div class="row">
                  <div
                    :class="[
                      'align-self-center',
                      customization.item_name && customization.item_name == 'Y'
                        ? 'col-5'
                        : 'col-5'
                    ]"
                  >
                    <span class="font-weight-semi-bold">{{
                      customization.item_name
                    }}</span>
                  </div>
                  <div class="col-2 align-self-center text-center">
                    <!-- {{ customization.customization_item_quantity }}&nbsp;{{
                      customization.uom_unit
                    }} -->
                  </div>
                  <!-- <div
                    class="col-2 align-self-center text-center"
                    v-if="
                      customization.is_extra_charges_applicable &&
                        customization.is_extra_charges_applicable == 'Y'
                    "
                  >
                    <span class="font-weight-semi-bold"
                      >{{ getFnBCurrency && getFnBCurrency.curr_code }}&nbsp;{{
                        customization.charges_value | RoundOff
                      }}</span
                    >
                  </div>
                  <div class="col-2 align-self-center text-center" v-else>
                    <span>-</span>
                  </div> -->
                  <div class="col-2 align-self-center text-center"></div>
                  <div class="col-3 text-right">
                    <button
                      @click="onSelectCustomization(customization)"
                      class="btn-outline-blue mx-0"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- customizable pop up ends-->

        <!-- alternate items pop up -->
        <b-modal
          size="lg"
          hide-footer
          id="alternate-itmes-modal"
          title="Please select Alternate item"
        >
          <div class="row fnb-item-list" v-if="smCardView">
            <div
              class="py-3 col-4"
              v-for="(food, key) in getAlternateItems"
              :key="key"
            >
              <div
                class="newCard row"
                @click="
                  onAddFnBList({ ...food, itemIndex: key });
                  onAddFnbItemCallback();
                "
                :style="
                  !!food.fc_bgColor
                    ? `background-color: ${food.fc_bgColor}`
                    : 'background-color: var(--lightblue)'
                "
              >
                <div class="col-5 d-flex align-items-center m-0 pl-1 p-0">
                  <div
                    class="food-img img-hover br-10"
                    style="cursor: pointer; border-radius: 10px"
                  >
                    <img
                      v-if="food.item_image_url"
                      v-lazy="_GetImagePath(food.item_image_url)"
                      height="80"
                      width="90"
                    />
                    <img
                      v-else-if="food.fc_icon_url"
                      v-lazy="_GetImagePath(food.fc_icon_url)"
                      :class="
                        food.fc_icon_url.toLowerCase().includes('png')
                          ? 'icon_img'
                          : ''
                      "
                      :height="
                        food.fc_icon_url.toLowerCase().includes('icon')
                          ? '80'
                          : ''
                      "
                      :width="
                        food.fc_icon_url.toLowerCase().includes('icon')
                          ? '90'
                          : ''
                      "
                    />
                    <img
                      v-else
                      v-lazy="_GetImagePath(food.item_image_url)"
                      height="80"
                      width="90"
                    />
                  </div>
                </div>
                <div class="col-7 position-parent mb-1">
                  <div
                    class="font-weight-bold"
                    :title="food.item_name"
                    :style="
                      !!food.fc_fontColor
                        ? `color: ${food.fc_fontColor}`
                        : 'color: var(--text)'
                    "
                  >
                    {{ food.item_name || food.recipe_name }}
                    <FoodMark
                      :isVeg="food.item_is_veg == 'Y' ? true : false"
                      :isEgg="food.includes_egg == 'Y' ? true : false"
                    />
                  </div>
                  <div class="product-action position-child">
                    <div class="" :style="'zoom: 0.8'">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <span
                          v-if="
                            food.has_alternate_items &&
                              food.has_alternate_items == 'Y'
                          "
                          class="s_price_text"
                          :style="
                            !!food.fc_fontColor
                              ? `color: ${food.fc_fontColor}`
                              : 'color: var(--text)'
                          "
                        >
                          Starts From</span
                        >
                        <strong
                          :style="
                            !!food.fc_fontColor
                              ? `color: ${food.fc_fontColor}`
                              : 'color: var(--text)'
                          "
                          class="fs-16"
                          style=""
                          >{{ food.fp_total_amount }}&nbsp;{{
                            getFnBCurrency.curr_code | uppercase
                          }}</strong
                        >
                        <span
                          :id="'tooltip-fnb-add-button-disable-' + (key + 1)"
                          v-if="false"
                        >
                          <button
                            :class="
                              food.isItemInStock ? 'c-pointer click-anim' : ''
                            "
                            v-bind:style="{
                              'pointer-events': !food.isItemInStock
                                ? 'none'
                                : 'all'
                            }"
                            class="btn-pos-add-white combo-btn-style"
                          >
                            +
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- alternate items pop up ends-->

        <!-- Combo Pack pop up -->
        <b-modal
          size="xl"
          hide-footer
          hide-header
          id="comboPackModal"
          ref="comboPackModal"
          title="Customise Your Combo"
        >
          <div class="combo-modal-wrapper">
            <div class="text-center font-weight-bold fs-20 my-2">
              <div class="mb-2" style="font-size: 22px">
                Customise Your Combo
              </div>
            </div>
            <div
              class="row mb-2"
              v-for="(category, categoryindex) in ComboPackArray"
              :key="categoryindex"
            >
              <div class="col-12 category-title">
                <div class="d-flex justify-content-between category-title-box">
                  <div>
                    {{ category.category_name }} &nbsp;&nbsp;&nbsp;
                    <span class="combo-item-count">
                      {{
                        category.combo_items
                          .filter(x => x.quantity > 0)
                          .map(y => y.quantity + "x -" + y.item_name)
                          .join(", ")
                      }}
                    </span>
                  </div>
                  <div class="quantityCount">
                    Selected:
                    {{ getComboItemSelectedByCategory(categoryindex) }} /
                    {{ category.quantity }}
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row fnb-item-list" v-if="smCardView">
                  <div
                    class="py-3 col-4"
                    v-for="(food, key) in category.combo_items"
                    :key="key"
                  >
                    <div
                      class="newCard row"
                      :style="
                        !!food.fc_bgColor
                          ? `background-color: ${food.fc_bgColor}`
                          : 'background-color: var(--lightblue)'
                      "
                    >
                      <!-- <span class="selectedComboItem-sm tick-green-item" v-if="food.quantity > 0"></span> -->
                      <div
                        class="selectedComboItem-sm"
                        v-if="food.quantity > 0"
                      >
                        <span class="tick-green-item"></span>
                      </div>
                      <div class="col-5 d-flex align-items-center m-0 pl-1 p-0">
                        <div
                          class="food-img img-hover br-10"
                          style="cursor:pointer; border-radius: 10px"
                        >
                          <img
                            v-if="food.item_image_url"
                            v-lazy="_GetImagePath(food.item_image_url)"
                            height="80"
                            width="90"
                          />
                          <img
                            v-else-if="food.fc_icon_url"
                            v-lazy="_GetImagePath(food.fc_icon_url)"
                            :class="
                              food.fc_icon_url.toLowerCase().includes('png')
                                ? 'icon_img'
                                : ''
                            "
                            :height="
                              food.fc_icon_url.toLowerCase().includes('icon')
                                ? '80'
                                : ''
                            "
                            :width="
                              food.fc_icon_url.toLowerCase().includes('icon')
                                ? '90'
                                : ''
                            "
                          />
                          <img
                            v-else
                            v-lazy="_GetImagePath(food.item_image_url)"
                            height="80"
                            width="90"
                          />
                        </div>
                      </div>
                      <div class="col-7 position-parent mb-1">
                        <div class="font-weight-bold" style="font-size:13px">
                          {{ food.item_name }}
                          <FoodMark
                            :isVeg="food.item_is_veg == 'Y' ? true : false"
                            :isEgg="food.includes_egg == 'Y' ? true : false"
                          />
                        </div>
                        <div class="product-action position-child">
                          <div class="" :style="'zoom: 0.8'">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <button
                                class="btn-pos-subtract-white combo-btn-style"
                                @click.prevent.stop="
                                  onChangeComboItems(
                                    food,
                                    key,
                                    category,
                                    categoryindex,
                                    'minus'
                                  )
                                "
                              >
                                &minus;
                              </button>
                              <strong class="fs-20" style="margin:0 10px">{{
                                food.quantity
                              }}</strong>
                              <button
                                class="btn-pos-add-white combo-btn-style"
                                @click.prevent.stop="
                                  onChangeComboItems(
                                    food,
                                    key,
                                    category,
                                    categoryindex,
                                    'add'
                                  )
                                "
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row fnb-item-list" v-else>
                  <div
                    class="py-3"
                    :style="'width: calc(100% / 5)'"
                    v-for="(food, key) in category.combo_items"
                    :key="key"
                  >
                    <div
                      class="combo-food-card mx-auto"
                      :class="food.quantity > 0 ? 'activeComboItems' : ''"
                    >
                      <div class="food-img img-hover" style="cursor:pointer">
                        <img
                          v-lazy="_GetImagePath(food.item_image_url)"
                          class="img-fluid"
                        />
                      </div>
                      <div
                        class="combo-detail-card"
                        :style="
                          !!food.fc_bgColor
                            ? `background-color: ${food.fc_bgColor}`
                            : 'background-color: var(--lightblue)'
                        "
                      >
                        <div
                          class="text-uppercase font-weight-bold combo-item-name"
                          :style="
                            !!food.fc_fontColor
                              ? `color: ${food.fc_fontColor}`
                              : 'color: var(--text)'
                          "
                        >
                          {{ food.item_name }}
                        </div>
                        <div class="text-white" :style="'zoom: 0.8'">
                          <div
                            class="px-3 d-flex align-items-center justify-content-between"
                          >
                            <button
                              class="btn-pos-subtract combo-btn-style"
                              @click.prevent.stop="
                                onChangeComboItems(
                                  food,
                                  key,
                                  category,
                                  categoryindex,
                                  'minus'
                                )
                              "
                            >
                              &minus;
                            </button>
                            <strong class="fs-20">{{ food.quantity }}</strong>
                            <button
                              class="btn-pos-add combo-btn-style"
                              @click.prevent.stop="
                                onChangeComboItems(
                                  food,
                                  key,
                                  category,
                                  categoryindex,
                                  'add'
                                )
                              "
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="selectedComboItem" v-if="food.quantity > 0">
                      <span class="tick-green-item"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center mt-4">
                <button
                  class="btn-blue"
                  :disabled="false"
                  :class="false ? 'disabled' : ''"
                  @click="onSaveComboChanges"
                >
                  {{ "Submit" }}
                </button>
                <button
                  class="btn-blue"
                  @click="$bvModal.hide('comboPackModal')"
                >
                  {{ "Cancel" }}
                </button>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- Combo Pack pop up ends-->

        <!-- RIGHT TOTAL PANEL -->
        <div class="col-lg-3 col-xl-3 pl-0 col-md-4 col-sm-4">
          <div class="pos-fnb-summary-box">
            <header class="summary-header">
              <!-- <button class="btn-pos-fnb-refresh">
                <img src="@/assets/img/icons/pos-refresh.svg" height="12" width="12" />
                <span class="font-weight-semi-bold">Refresh</span>
              </button>-->
              <!-- <button
                v-if="showViewOffers"
                class="btn-pos-fnb-add-on"
                @click="onClickAddOnButton()"
              >
                Add-Ons
              </button> -->
              <!-- <button
                v-if="showViewOffers"
                class="btn-pos-fnb-view-offers"
                v-b-modal.pos-applicable-offers
              >
                View Offers
              </button> -->
              <div class="col-12" v-if="getCustomerDetails.first_name">
                <div class="row border-bottom-lightgrey py-2">
                  <div class="col-5">
                    <span class="text-lightgrey">{{ $tc("customer", 1) }}</span>
                  </div>
                  <div class="col-7 px-0 overflow-hidden">
                    <strong
                      >{{ getCustomerDetails.first_name }}
                      {{ getCustomerDetails.last_name }}</strong
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 py-2">
                <div class="row">
                  <div class="col-4">
                    <span class="text-lightgrey">Item</span>
                  </div>
                  <div class="col-4 px-0 text-center">
                    <span class="text-lightgrey">Qty</span>
                  </div>
                  <div class="col-4 text-right">
                    <span class="text-lightgrey pr-4 mr-2">Price</span>
                  </div>
                </div>
              </div>
            </header>

            <div class="summary-content">
              <div
                class="col-12"
                v-for="(orders, index) in SelectedFnbItemList"
                :key="index"
              >
                <div class="row align-items-center py-2">
                  <div
                    :class="windowWidth <= 1024 ? 'col-5 pl-2' : 'col-4 pl-2'"
                    class="font_size_12"
                  >
                    <div>
                      <span class="font-weight-bold font_size_12">{{
                        orders.item_name
                      }}</span>
                      <p
                        class="font_size_12 text-blue mb-0 c-pointer click-anim"
                        @click="
                          onFetchCustomization({
                            item_id: orders.item_id,
                            customization_common_id:
                              orders.customization_common_id
                          })
                        "
                        v-if="
                          orders.is_customization_available &&
                            orders.is_customization_available == 'Y'
                        "
                      >
                        (customise)
                      </p>
                      <p
                        @click="
                          onFetchAlternateItems({
                            item_id: orders.item_id,
                            index: index,
                            quantity: orders.quantity
                          })
                        "
                        class="font_size_12 text-blue mb-0 c-pointer click-anim"
                        v-if="
                          orders.has_alternate_items &&
                            orders.has_alternate_items == 'Y'
                        "
                      >
                        (Alternate)
                      </p>
                    </div>
                  </div>
                  <div
                    class="
                    col-4
                      px-0
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <!-- :class="windowWidth <= 1024 ? 'col-3' : 'col-4'" -->
                    <!--  -->
                    <button
                      v-if="orders.item_id == getSelectedOffer.oc_get_item_id"
                      class="btn-pos-subtract"
                      :class="orders.Qty < 2 ? 'opacity-50' : ''"
                      v-on:click="onDecreaseOfferFnBItem({ index })"
                    >
                      &minus;
                    </button>
                    <button
                      v-else
                      class="btn-pos-subtract"
                      :class="orders.Qty < 2 ? 'opacity-50' : ''"
                      v-on:click="
                        onDecreaseFnBItem({ index });
                        applyFnbOffersHandler({
                          event: null,
                          offer: getSelectedOffer,
                          offerFor: getOfferFor
                        });
                      "
                    >
                      &minus;
                    </button>
                    <strong class="font_size_12">{{ orders.quantity }}</strong>
                    <button
                      class="btn-pos-add"
                      v-if="orders.item_id == getSelectedOffer.oc_get_item_id"
                      v-on:click="onIncreaseFnBItem({ index })"
                    >
                      +
                    </button>
                    <button
                      class="btn-pos-add"
                      v-else
                      v-on:click="
                        onIncreaseFnBItem({ index });
                        applyFnbOffersHandler({
                          event: null,
                          offer: getSelectedOffer,
                          offerFor: getOfferFor
                        });
                      "
                    >
                      +
                    </button>
                  </div>
                  <div
                    :class="windowWidth <= 1024 ? 'col-3' : 'col-4'"
                    class="font_size_12"
                  >
                    <div
                      class="
                        d-flex
                        w-100
                        align-items-center
                        justify-content-between
                      "
                    >
                      <strong class="font_size_12">{{
                        orders.fp_total_amount | RoundOff
                      }}</strong>
                      <button
                        class="btn-pos-delete"
                        v-on:click="
                          onRemoveFnBList({ index });
                          applyFnbOffersHandler({
                            event: null,
                            offer: getSelectedOffer,
                            offerFor: getOfferFor
                          });
                        "
                      ></button>
                    </div>
                  </div>
                  <div
                    class="col-12 pt-2"
                    v-if="
                      orders.hasOwnProperty('customizations') &&
                        orders['customizations'].length > 0
                    "
                  >
                    <div class="row">
                      <div class="col-12 align-self-center">
                        <div
                          class="my-1 row"
                          v-for="(singleCustomItem,
                          singleCustomItemIndex) in orders['customizations']"
                          :key="singleCustomItemIndex"
                        >
                          <span class="font_size_12 text-muted col-10">{{
                            singleCustomItem.item_name
                          }}</span>
                          <div class="col-2">
                            <span
                              class="icon-delete cursor-pointer font_size_12"
                              v-on:click="
                                onRemoveCustomization({
                                  item_id: orders.item_id,
                                  customization_id:
                                    orders.customizations[0].item_id
                                })
                              "
                              v-if="
                                orders.hasOwnProperty('customizations') &&
                                  orders['customizations'].length > 0
                              "
                            ></span>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-4">
                        <button
                          class="btn-outline-blue btn-sm mw-auto mx-0 w-100"
                          @click="
                            onFetchCustomization({
                              item_id: orders.item_id,
                              customization_common_id:
                                orders.customization_common_id
                            })
                          "
                          v-if="
                            orders.is_customization_available &&
                              orders.is_customization_available == 'Y'
                          "
                        >
                          Edit
                        </button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    class="col-12 pt-2 "
                    v-if="
                      orders.hasOwnProperty('is_combo') &&
                        orders.hasOwnProperty('combo_pack') &&
                        orders.is_combo == 'Y' &&
                        orders['combo_pack'].length > 0
                    "
                  >
                    <div class="row">
                      <div class="col-7 align-self-center">
                        <div
                          v-for="(singleCategory,
                          singleCategoryIndex) in orders['combo_pack']"
                          :key="singleCategoryIndex"
                        >
                          <div
                            class="my-1 row justify-content-start"
                            v-for="(comboItem,
                            comboItemIndex) in singleCategory.combo_items"
                            v-if="comboItem.quantity > 0"
                            :key="comboItemIndex"
                          >
                            <span class="font_size_12 text-muted col-9"
                              >{{ comboItem.item_name }}
                            </span>
                            <span class="font_size_12 text-muted col-2"
                              >x{{ comboItem.quantity }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-5 align-items-center">
                        <button
                          class="font_size_12 btn-outline-blue btn-sm mw-auto mx-0 w-100 br-20"
                          @click="onCustomizeCombo(orders, index)"
                        >
                          Customise
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-0" />
              </div>
              <!-- ADDONS -->
              <div
                class="col-12"
                v-for="(addon, addOnIndex) in selectedAddons"
                :key="addon.add_on_item_name + addOnIndex"
              >
                <div class="row align-items-center py-2">
                  <div class="col-4 pr-2">
                    <small class="font_size_12 font-weight-bold">{{
                      addon.add_on_item_name
                    }}</small>
                  </div>
                  <div
                    class="
                      col-4
                      px-0
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <button
                      class="btn-pos-subtract"
                      v-on:click="onDecreaseAddonItem({ index: addOnIndex })"
                    >
                      &minus;
                    </button>
                    <strong class="font_size_12">{{ addon.quantity }}</strong>
                    <button
                      class="btn-pos-add"
                      v-on:click="onIncreaseAddonItem({ index: addOnIndex })"
                    >
                      +
                    </button>
                  </div>
                  <div class="col-4">
                    <div
                      class="
                        d-flex
                        w-100
                        align-items-center
                        justify-content-between
                      "
                    >
                      <strong class="font_size_12">{{
                        (addon.add_on_item_price * addon.quantity) | RoundOff
                      }}</strong>
                      <button
                        class="btn-pos-delete"
                        v-on:click="onRemoveAddonList({ index: addOnIndex })"
                      ></button>
                    </div>
                  </div>
                </div>

                <hr class="my-0" />
              </div>
              <!-- addon ends here -->
              <div
                v-if="
                  SelectedFnbItemList.length === 0 && selectedAddons.length == 0
                "
                class="font_size_12 text-center h-100 d-flex align-items-center"
              >
                <div>
                  <img
                    src="@/assets/img/icons/select-food.png"
                    class="w-50 pb-4"
                    alt
                  />
                  <h5 class="font_size_12">
                    Your cart is empty.
                    <br />Add an item to begin.
                  </h5>
                </div>
              </div>
            </div>

            <footer class="summary-footer">
              <div class="col-12 py-1">
                <div class="row">
                  <div class="col-4">
                    <span class="text-lightgrey font_size_12">Sub Total</span>
                  </div>
                  <div class="col-8 text-right font_size_12">
                    <strong class="font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{
                        currFormat(selectedFnBItemsTotalPrice)
                      }}</strong
                    >
                  </div>
                </div>
              </div>

              <!-- ADDON EXTRA CHARGES -->
              <div class="col-12 py-1" v-if="selectedAddons.length > 0">
                <div v-if="addonsAdditionalCharges.length == 0" class="row">
                  <div class="col-4">
                    <span class="text-lightgrey font_size_12">Tax</span>
                  </div>
                  <div class="col-8 text-right font_size_12">
                    <div>{{ getFnBCurrency.curr_code | uppercase }}&nbsp;0</div>
                  </div>
                </div>
                <div
                  v-if="addonsAdditionalCharges.length > 0"
                  v-for="(AdditionalTax,
                  AdditionalTaxIndex) in addonsAdditionalCharges"
                  :key="AdditionalTaxIndex + AdditionalTax.ct_name"
                  class="row"
                >
                  <div class="col-5">
                    <span class="text-lightgrey font_size_12">{{
                      AdditionalTax.ct_name | uppercase
                    }}</span>
                  </div>
                  <div class="col-7 text-right">
                    <div class="font_size_12">
                      {{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(AdditionalTax.totalTax)
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- ENDS -->

              <!-- CUSTOMIZATIONS -->
              <div
                class="col-12 py-1"
                v-if="selectedChargeableCustomizations.length > 0"
                v-for="(singleItem,
                singleItemIndex) in selectedChargeableCustomizations"
                :key="singleItemIndex"
              >
                <div class="row">
                  <div class="col-7">
                    <span class="text-black font_size_12">{{
                      singleItem.item_name
                    }}</span>
                  </div>
                  <div class="col-5 text-right font_size_12">
                    <strong class="font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(singleItem.fp_total_amount)
                      }}</strong
                    >
                  </div>
                </div>
              </div>
              <!-- CUSTOMIZATIONS -->
              <!-- CUSTOMIZATIONS TAXES-->
              <div
                class="col-12 py-1"
                v-if="customizationAdditionalTaxes.length > 0 && false"
              >
                <div
                  v-for="(singleCharge,
                  singleChargeIndex) in customizationAdditionalTaxes"
                  :key="singleChargeIndex"
                  class="row"
                >
                  <div class="col-7">
                    <span class="text-black font_size_12">{{
                      singleCharge.ct_name
                    }}</span>
                  </div>
                  <div class="col-5 text-right">
                    <strong class="font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(singleCharge.frcs_amount)
                      }}</strong
                    >
                  </div>
                </div>
              </div>
              <!-- CUSTOMIZATIONS TAXES-->

              <div class="col-12 py-1">
                <div v-if="AdditionalTaxList.length === 0" class="row">
                  <div class="col-7">
                    <span class="text-lightgrey font_size_12">Tax</span>
                  </div>
                  <div class="col-5 text-right">
                    <strong class="font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;0</strong
                    >
                  </div>
                </div>

                <div
                  v-if="AdditionalTaxList.length > 0"
                  v-for="(AdditionalTax,
                  AdditionalTaxIndex) in AdditionalTaxList"
                  :key="AdditionalTaxIndex"
                  class="row"
                >
                  <div class="col-7">
                    <span class="text-black font_size_12">{{
                      AdditionalTax.ct_name | uppercase
                    }}</span>
                  </div>
                  <div class="col-5 text-right">
                    <strong class="font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(AdditionalTax.totalTax)
                      }}</strong
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="
                  offerPrice &&
                    offerPrice > 0 &&
                    Object.keys(offerApplied).length > 0 &&
                    false
                "
                class="col-12"
              >
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12"
                      >Offer Applied</span
                    >
                    <strong class="font_size_12">{{
                      offerApplied.offer_title || offerApplied.offer_code
                    }}</strong
                    >&nbsp;
                    <img
                      class="d-table position-relative"
                      src="@/assets/img/icons/question2.svg"
                      v-b-tooltip.hover
                      title="Offer Details here"
                      height="20"
                      width="20"
                    />
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block font_size_12"
                        >{{ currFormat(offerPrice) }}&nbsp;{{
                          currencyData.curr_code
                        }}</strong
                      >
                      <img
                        @click="onResetOffersAndPrice()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="20"
                        width="20"
                      />
                    </div>
                  </div>
                  <div class="col-7 px-0">
                    <strong class="d-block text-right font_size_12">
                      <!-- {{ offerApplied.oc_discount_value }} {{currencyData.curr_code}} -->
                      {{ getFnBCurrency.curr_code | uppercase }}&nbsp;-{{
                        currFormat(offerPrice)
                      }}
                    </strong>
                  </div>
                </div>
              </div>
              <div
                v-if="offerApplied && Object.keys(offerApplied).length > 0"
                class="col-12"
              >
                <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <!-- class="text-lightgrey" -->
                    <strong class="font_size_12">Offer Applied</strong>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-end">
                      <strong class="font_size_12 d-block text-danger"
                        ><span class="font_size_12"
                          >-{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                            offerPrice
                          }}</span
                        ></strong
                      >
                    </div>
                  </div>
                  <div class="col-12 pt-1 px-0 d-flex">
                    <!-- <Tooltip
                      :title="`Offer Details here`"
                      :src="`question2.svg`"
                    /> -->
                    <strong class="fs-10 mr-2 pt-1 font_size_12"
                      >({{
                        offerApplied.offer_title ||
                          offerApplied.offer_code ||
                          offerApplied.voucher_title ||
                          offerApplied.voucher_code
                      }})</strong
                    >
                    <img
                      @click="onRemoveOffer()"
                      class="d-table position-relative"
                      src="@/assets/img/icons/delete.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                  <div class="col-4 pr-0">
                    <div class="d-flex w-100 justify-content-between"></div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  RemainingCashRefundOfferAmount &&
                    parseInt(RemainingCashRefundOfferAmount) > 0
                "
                class="col-12"
              >
                <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <!-- class="text-lightgrey" -->
                    <strong class="font_size_12">Cash Refund</strong>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-end">
                      <strong class="d-block text-danger font_size_12"
                        ><span class="font_size_12"
                          >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                            RemainingCashRefundOfferAmount
                          }}</span
                        ></strong
                      >
                    </div>
                  </div>

                  <div class="col-4 pr-0">
                    <div class="d-flex w-100 justify-content-between"></div>
                  </div>
                </div>
              </div>
              <div v-if="isCashCardTransaction" class="col-12">
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12">Cash Card</span>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block font_size_12">{{
                        isCashCardDetail.cash_card_number
                      }}</strong>
                    </div>
                  </div>
                </div>
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12"
                      >Cash Card Amount</span
                    >
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between text-danger">
                      <strong class="font_size_12"
                        >-{{
                          isCashCardDetail && isCashCardDetail.cardAmount
                            ? parseFloat(isCashCardDetail.cardAmount).toFixed(2)
                            : "0.00"
                        }}&nbsp;{{
                          getFnBCurrency.curr_code | uppercase
                        }}</strong
                      >
                      <img
                        @click="onRemoveCashCard()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="20"
                        width="20"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isLoyaltyApplied" class="col-12">
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12"
                      >Loyalty Applied</span
                    >
                    <strong>{{ LoyaltyProgram }}</strong
                    >&nbsp;
                    <div class="d-flex">
                      <img
                        class="d-table position-relative"
                        src="@/assets/img/icons/question2.svg"
                        v-b-tooltip.hover
                        :title="LoyaltyProgram"
                        height="18"
                        width="18"
                      />
                      <img
                        @click="resetLoyaltyData()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="18"
                        width="18"
                      />
                    </div>
                  </div>
                  <div class="col-7 px-0">
                    <strong class="d-block text-right font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(getloyaltyAmount)
                      }}</strong
                    >
                    <div class="d-flex flex-wrap mt-2"></div>
                  </div>
                </div>
              </div>

              <div class="col-12" v-if="MeritCardAmount > 0 && GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y'">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Merit Gift Card</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ GET_MERIT_GIFT_CARD_DETAILS.card_number }}</strong>
                  </div>
                </div>
                <div class="d-flex border-bottom-lightgrey py-1 text-danger">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Gift Card Amount</span>
                  </div>
                  <div class="col-7 px-0 d-flex align-item-center justify-content-between pr-3">
                    <strong
                      >-{{
                        MeritCardAmount > 0 && GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y'
                          ? parseFloat(MeritCardAmount).toFixed(2)
                          : "0.00"
                      }}&nbsp;{{ currencyData.curr_code }}</strong
                    >
                    <img
                      @click="onRemoveMeritGiftCard()"
                      class="d-table position-relative"
                      src="@/assets/img/icons/delete.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                </div>
              </div>

              <div class="col-12 py-1">
                <div class="row">
                  <div class="col-4">
                    <span class="text-black font_size_12">Total</span>
                  </div>
                  <div class="col-8 text-right">
                    <strong class="font_size_12"
                      >{{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{
                        parseFloat(finalGrossAmount).toFixed(2)
                      }}</strong
                    >
                  </div>
                </div>
              </div>

              <div class="col-12 py-1 px-1 border-top pt-2" v-if="EmpireClient">
                <div class="dropdown-curve-container">
                  <label
                    :class="selectedStation_temp.station_id ? 'shift-up' : ''"
                  >
                    Fnb Station
                  </label>

                  <multiselect
                    v-model="selectedStation_temp"
                    @select="onSelectFnbStation($event, 'select')"
                    @remove="onSelectFnbStation($event, 'remove')"
                    placeholder=""
                    :options="stationsArray"
                    label="station_name"
                    track-by="station_id"
                    :multiple="false"
                    name="station_name"
                    id="station_name"
                    :showLabels="false"
                  >
                  </multiselect>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </section>
    <!-- Offer Modal  -->
    <b-modal
      ref="applicable-offer-modal"
      id="pos-applicable-offers"
      size="lg"
      hide-header
      hide-footer
    >
      <div>
        <h4 class="text-center py-3 font_size_12">All Applicable Offers:</h4>
        <button class="btn-modal-close" @click="closeApplicableOffersModal">
          &times;
        </button>
        <b-tabs content-class="mt-3">
          <b-tab
            title="Offers &amp; Promotions"
            v-if="getOffersCollection.length > 0"
          >
            <div class="applicable-offer-wrapper">
              <ul class="pos-applicable-offers-list">
                <li
                  class="font_size_12"
                  v-for="(OffersItem, OffersIndex) in getOffersCollection"
                  :key="OffersIndex"
                  v-if="checkOfferType(OffersItem)"
                >
                  <div
                    name="applicableOffers"
                    v-model="ApplicableOfferSelected"
                    class="j-radio"
                  >
                    <!-- <div v-if="String(OffersItem.offer_type_id) === '1'">
                  <strong>{{ OffersItem.offer_code }}</strong>
                  Buy {{ OffersItem.oc_buy_no_of_ticket }} Tickets Get {{ OffersItem.oc_get_free_ticket }} Tickets Free
                </div>
                <div v-else-if="String(OffersItem.offer_type_id) === '2'">
                  <strong>{{ OffersItem.offer_code }}</strong>
                  Buy {{ OffersItem.oc_buy_no_of_ticket }} Tickets &amp; Get Discount of {{ OffersItem.oc_discount_value }} {{ OffersItem.oc_discount_value_is_percentage === 'Y' ? '%': currencyData['curr_code'] }}
                    </div>-->
                    <div
                      v-if="String(OffersItem.offer_type_id) === '2'"
                      class="font_size_12"
                    >
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Buy {{ OffersItem.oc_buy_no_of_ticket }}
                      {{
                        OffersItem.offer_redeem_at_concession == "Y"
                          ? "Tickets/Items"
                          : "Tickets"
                      }}
                      &amp; Get Discount of {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '3'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Combo Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '4'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      {{ OffersItem.buc_category_name }} Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '5'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Bank Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '6'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Promo code Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '7'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      <br />
                      Buy {{ OffersItem.oc_buy_no_of_ticket }}
                      {{
                        OffersItem.offer_redeem_at_concession == "Y"
                          ? "Tickets/Items"
                          : "Tickets"
                      }}
                      &amp; Get Flat {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                      OFF.&nbsp;Only for Loyality Members
                    </div>
                    <div v-else-if="OffersItem.offer_type_id == '8'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Get Flat {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                      OFF
                    </div>
                    <div v-else-if="OffersItem.offer_type_id == '9'">
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      {{ getOfferDescription(OffersItem) }}
                    </div>
                    <div v-else>
                      <strong class="font_size_12">{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Not Available
                    </div>
                  </div>
                  <!-- onApplyOffer(OffersItem) -->
                  <button
                    :disabled="offerApplied.offer_code == OffersItem.offer_code"
                    @click="
                      onClickApplyOffer({
                        event: $event,
                        offer: OffersItem,
                        offerFor: 'fnbOffers'
                      })
                    "
                    class="btn-blue font_size_12"
                  >
                    Apply
                  </button>
                  <button
                    v-b-toggle="'offer-details-' + OffersItem.os_id"
                    class="btn-transparent"
                  >
                    <small class="font_size_12">Show Details</small>
                  </button>

                  <b-collapse :id="'offer-details-' + OffersItem.os_id">
                    <ul
                      v-if="String(OffersItem.offer_type_id) === '1'"
                      class="small pt-3 font_size_12"
                    >
                      <li class="py-1 font_size_12">
                        Minimun Ticket Price:
                        {{ OffersItem.oc_min_ticket_price }}
                      </li>
                      <li class="py-1 font_size_12">
                        Maximum Free Tickets Per Transactions:
                        {{ OffersItem.oc_max_no_of_ticket_per_transaction }}
                      </li>
                    </ul>
                    <ul
                      v-else-if="
                        String(OffersItem.offer_type_id) === '2' ||
                          String(OffersItem.offer_type_id) === '8'
                      "
                      class="small pt-3 font_size_12"
                    >
                      <li class="py-1 font_size_12">
                        Maximum discount per transaction:
                        {{ OffersItem.oc_max_discount_amount }}
                      </li>
                      <!-- <li class="py-1">Maximum Free Tickets Per Transactions: {{ OffersItem.oc_max_no_of_ticket_per_transaction }}</li> -->
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '3'"
                      class="small pt-3 font_size_12"
                    >
                      <li class="py-1 font_size_12">
                        Offer Combine With:
                        {{
                          OffersItem.oc_is_combo_with_fnb === "Y"
                            ? "F&B"
                            : "BoxOffice"
                        }}
                      </li>
                      <li
                        class="py-1 font_size_12"
                        v-if="OffersItem.oc_is_combo_with_fnb === 'Y'"
                      >
                        Buy {{ OffersItem.oc_buy_item_count }}
                        {{ OffersItem.buy_item_name }} F&amp;B Item &amp; Get
                        {{ OffersItem.oc_get_item_count }}
                        {{ OffersItem.get_item_name }} F&amp;B Item
                        <span
                          v-if="OffersItem.oc_is_combo_free === 'Y'"
                          class="font_size_12"
                          >{{ "Is Free" }}</span
                        >
                        <span
                          v-if="OffersItem.oc_is_combo_free === 'N'"
                          class="font_size_12"
                          >{{ OffersItem.oc_discount_value }}
                          {{
                            OffersItem.oc_discount_value_is_percentage === "Y"
                              ? "% OFF"
                              : `${currencyData["curr_code"]} OFF`
                          }}</span
                        >
                      </li>
                      <li
                        class="py-1"
                        v-if="OffersItem.oc_is_combo_with_fnb === 'N'"
                      >
                        Buy Tickets {{ OffersItem.oc_buy_no_of_ticket }} &amp;
                        Get F&amp;B Item {{ OffersItem.get_item_name }}
                        <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                          "Is Free"
                        }}</span>
                        <span v-if="OffersItem.oc_is_combo_free === 'N'"
                          >{{ OffersItem.oc_discount_value }}
                          {{
                            OffersItem.oc_discount_value_is_percentage === "Y"
                              ? "% OFF"
                              : `${currencyData["curr_code"]} OFF`
                          }}</span
                        >
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '4'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.cco_min_ticket_amount }}
                      </li>
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.cco_max_discount_amount }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.cco_offer_value }}
                        {{
                          OffersItem.cco_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.cco_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '5'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Bank Name: {{ OffersItem.bank_name }}
                      </li>
                      <li class="py-1">
                        Bank Card: {{ OffersItem.card_type }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_weekly_redemption">
                        {{ "Weekly" }} Redemption:
                        {{ OffersItem.bo_weekly_redemption }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_monthly_redemption">
                        {{ "Monthly" }} Redemption:
                        {{ OffersItem.bo_monthly_redemption }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_yearly_redemption">
                        {{ "Yearly" }} Redemption:
                        {{ OffersItem.bo_yearly_redemption }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.bo_offer_value }}
                        {{
                          OffersItem.bo_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.bo_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '6'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Promo Code: {{ OffersItem.promo_code }} applicable for
                        {{
                          OffersItem.pcs_no_of_transactions
                            ? OffersItem.pcs_no_of_transactions
                            : "N/A"
                        }}
                        Transactions
                      </li>
                      <input
                        placeholder="."
                        type="text"
                        :value="promoCode"
                        @input="
                          onEnterPromoCodes({
                            event: $event,
                            name: 'enterPromoCode'
                          })
                        "
                        name="promocode"
                        id="promocode"
                      />
                      <li class="py-1">
                        Categories: {{ OffersItem.booking_user_category_id }}
                      </li>
                      <li class="py-1">
                        Minimum Ticket Price:
                        {{ OffersItem.pcs_min_ticket_amount }}
                      </li>
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.pcs_max_discount_amount }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.pcs_offer_value }}
                        {{
                          OffersItem.pcs_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.pcs_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="[9, 10].includes(OffersItem.offer_type_id)"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        {{ getOfferDescription(OffersItem, true) }}
                      </li>
                      <li class="py-1" v-if="OffersItem.pcs_instruction">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.pcs_instruction"></span>
                      </li>
                    </ul>
                    <ul v-else class="small pt-3">
                      <li class="py-1"></li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-tab>
          <b-tab title="Vouchers" lazy>
            <!-- <div class="applicable-offer-wrapper">Sorry! There is no records found</div> -->
            <div class="applicable-offer-wrapper">
              <ul
                class="pos-applicable-offers-list"
                v-if="
                  getOffersVoucherCollection &&
                    getOffersVoucherCollection.length > 0
                "
              >
                <li
                  class
                  v-for="(OffersVoucherItem,
                  OffersVoucherIndex) in getOffersVoucherCollection"
                  :key="OffersVoucherIndex"
                  v-if="OffersVoucherItem.is_open_voucher == 'N'"
                >
                  <b-form-radio
                    name="applicableOffers"
                    v-model="ApplicableOfferSelected"
                    class="j-radio"
                  >
                    <div>
                      <strong
                        >{{
                          OffersVoucherItem.is_code_required == "N"
                            ? OffersVoucherItem.voucher_code + " -"
                            : ""
                        }}
                        {{ OffersVoucherItem.voucher_title }}</strong
                      >
                    </div>
                  </b-form-radio>

                  <!-- @click="onApplyOffer(OffersItem)" -->
                  <button
                    @click="checkVoucherDetails(OffersVoucherItem)"
                    class="btn-blue"
                  >
                    Apply
                  </button>
                  <button
                    v-b-toggle="
                      'offer-voucher-details-' + OffersVoucherItem.voucher_id
                    "
                    class="btn-transparent"
                  >
                    <small>Show Details</small>
                  </button>

                  <b-collapse
                    :id="
                      'offer-voucher-details-' + OffersVoucherItem.voucher_id
                    "
                  >
                    <ul class="small pt-3">
                      <li
                        v-if="OffersVoucherItem.hasMultiple == 'Y'"
                        class="py-1"
                      >
                        <input
                          placeholder="."
                          type="text"
                          :value="voucherCodeValue"
                          @input="
                            onEnterVoucherCode({
                              event: $event,
                              name: 'enterVoucherCode'
                            })
                          "
                          name="voucherCode"
                          id="voucherCode"
                        />
                      </li>
                      <li class="py-1">
                        Voucher value: {{ OffersVoucherItem.voucher_amount
                        }}{{
                          OffersVoucherItem.voucher_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Min Bill/ticket amount for redemption:
                        {{ OffersVoucherItem.voucher_min_redemption_amount }}
                      </li>
                      <li class="py-1">
                        Max Bill/ticket amount for redemption:
                        {{ OffersVoucherItem.voucher_max_redemption_amount }}
                      </li>
                      <li class="py-1">
                        Terms &amp; Conditions:
                        <br />
                        <span v-html="OffersVoucherItem.voucher_terms"></span>
                      </li>
                      <li v-if="OffersVoucherItem.vp_partner_name" class="py-1">
                        Partner Name:
                        <br />
                        <span v-html="OffersVoucherItem.vp_partner_name"></span>
                      </li>
                      <!--  -->
                    </ul>
                    <!-- <ul v-else class="small pt-3">
                      <li class="py-1"></li>
                    </ul>-->
                  </b-collapse>
                </li>
              </ul>

              <ul v-else>
                <li>
                  <div>No Vouchers Found</div>
                </li>
              </ul>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>

    <PosFnbFooter :onClickHandler="onClickCall" />

    <FnbRefund v-if="childComponents.FnbRefund" :onClickHandler="onClickCall" />

    <PosFnbPickup
      v-if="childComponents.PosFnbPickup"
      :itemsList="SelectedFnbItemList"
      :taxesTotal="TotalAdditionalTaxes"
      :taxes="AdditionalTaxList"
      :subTotal="selectedFnBItemsTotalPrice"
      :currency="getFnBCurrency.curr_code"
      :onPrintCall="GoToRoute"
      :printText="printText"
      :onClickHandler="onClickCall"
    />
    <PosUserFnBTransaction
      v-if="childComponents.posUserFnbTransaction"
      :onClickHandler="onClickCall"
    />
    <PosMultiFnB
      v-if="childComponents.PosMultiFnB"
      :onClickHandler="onClickCall"
    />

    <!-- MULTIPLE FNB ITEMS MODAL -->
    <!-- <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      size="sm"
      id="multi-fnb"
      ref="multi-fnb"
      title="Add multiple items"
    >
      <div class="pt-3">
        <p class="text-center">
          Enter number of quantity for
          <br />
          <span class="font-weight-semi-bold">{{ ItemDetails.item_name }}</span> to be added.
        </p>
        <div class="pos-min-height-wrapper d-flex align-items-center">
          <div class="pos-mobile-number">
            <form>
              <div class="row">
                <div class="col-12 mb-4">
                  <input
                    type="text"
                    autofocus
                    v-model="Increasedquantity"
                    @change="inputChange($event)"
                    placeholder="Quantity"
                  />
                </div>

                <div class="col-11 mx-auto">
                  <div class="row">
                    <div class="col-4 mb-2" v-for="(loop , mobile) in 11" :key="mobile">
                      <button
                        @click.prevent.stop="onClickNumber(mobile)"
                        v-if="mobile < 10"
                      >{{ mobile }}</button>
                      <button v-else @click.prevent.stop="clearInput">C</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="text-center mt-4">
          <button @click.prevent.stop="AddQuantityForItem()" class="btn-blue-lg px-4">Add Items</button>
        </div>
      </div>
    </b-modal>-->

    <!-- FILTER -->
    <b-modal
      ref="reffilterFnbItems"
      id="filterFnbItems"
      title="Filter "
      hide-footer
      hide-header
    >
      <div class="col-12 text-center border-bottom">
        <h5 class="py-2 font_size_12">Filter Items</h5>
      </div>
      <div class="my-2" style="max-height: 50vh; overflow: auto">
        <b-form-group class="mt-3">
          <b-form-checkbox-group
            text-field="fc_category"
            value-field="fc_id"
            size="lg"
            :options="fnbSubSubCategories"
            plain
            stacked
            @input="setOnFnBPayloads({ event: $event, name: 'subCategory' })"
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="col-12 text-center border-top pt-3">
        <button
          @click="$refs['reffilterFnbItems'].hide()"
          class="btn-white-lg mr-1"
        >
          Cancel
        </button>
        <button @click="fetchFnBItems" class="btn-blue-lg ml-1">Filter</button>
      </div>
    </b-modal>
    <b-modal
      id="verifyVoucherFnb"
      ref="verifyVoucherFnb"
      title="Verify Voucher"
      hide-footer
      show
      @hide="clearVoucherCode"
      @shown="handleOpenVoucherCodeModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Voucher Code"
              type="text"
              autofocus
              v-model="voucherCodeValue"
              v-on:keyup.enter="
                applyFnbOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'fnbVouchers',
                  checkSpecificTitle: 'Y'
                })
              "
              @input="
                onEnterVoucherCode({
                  event: $event,
                  name: 'enterVoucherCode'
                })
              "
              name="voucherCode2"
              id="voucherCode2"
              class="form-control"
              ref="voucherCodemodal"
            />
            <label>{{ "Enter Voucher Code" }}</label>
            <VkeyboardFloat
              :ID="'voucherCode2'"
              :onClickFun="
                () => {
                  Object.keys(keyboardsVisible).map(x => {
                    if (x == 'showVerifyVoucher') {
                      keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                      keyboardsVisible[x] = false;
                    }
                  });
                }
              "
            />
            <Vkeyboard
              :inputName="'voucherCode2'"
              :showOrHide="keyboardsVisible.showVerifyVoucher"
              :initialValue="voucherCodeValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="
                applyFnbOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'fnbVouchers',
                  checkSpecificTitle: 'Y'
                })
              "
              @changeKeyboardInput="
                event => {
                  voucherCodeValue = event;
                  onEnterVoucherCode({
                    event: {
                      target: {
                        value: event
                      }
                    },
                    name: 'enterVoucherCode'
                  });
                }
              "
              @onClickClose="
                () => {
                  keyboardsVisible.showVerifyVoucher = false;
                }
              "
            />
          </div>
          <div class="col-12 py-2 text-center">
            <button
              @click="
                applyFnbOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'fnbVouchers',
                  checkSpecificTitle: 'Y'
                })
              "
              class="btn-blue ml-5"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <ManagerAuthLogin
      :moduleName="'posOfferAuth_pos_fnb'"
      :onCheckAuth="onCheckOfferAuth"
      :refId="'posOfferAuth_pos_fnb'"
    />
     <AddEmployeeDiscountDetails :moduleName="'pos_fnb'" :refId="'addEmployeeDetails_pf'" :onCheckEmployeeDetails="onCheckEmployeeDetails"/>

  </div>
</template>

<script>
import posFnBHeader from "@/components/Partials/posFnBHeader";
import PosFnbFooter from "@/components/Partials/posFnbFooter";
import FnbRefund from "@/components/Partials/FnbRefund.vue";
import PosFnbPopcorn from "@/components/Pages/PosFnbContainer/posFnbPopcorn";
import PosFnbCheckout from "@/components/Pages/PosFnbContainer/posFnbCheckout";
import PosFnBFinalTicket from "@/components/Pages/PosFnbContainer/posFnBFinalTicket";
import PosFnbPickup from "@/components/Pages/PosFnbContainer/posPickupFnB";
import PosUserFnBTransaction from "@/components/Pages/PosBookingContainer/posUserFnbTransaction";
import PosMultiFnB from "@/components/Pages/PosFnbContainer/posMultiFnB";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import _ from "lodash";
import FoodMark from "@/components/UIElements/VegMark.vue";
import { EventBus } from "@/main";
import MasterService from "@/services/MasterService.js";
import { CLIENT_NAME } from "@/helper/Role";
import { backendSocket } from "@/main.js";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import AddEmployeeDiscountDetails from "@/components/Partials/AddEmployeeDiscountDetails";

export default {
  components: {
    posFnBHeader,
    PosFnbFooter,
    PosFnbPopcorn,
    PosFnbCheckout,
    PosFnBFinalTicket,
    FnbRefund,
    PosFnbPickup,
    PosUserFnBTransaction,
    PosMultiFnB,
    VkeyboardFloat,
    Vkeyboard,
    FoodMark,
    AddEmployeeDiscountDetails,
    ManagerAuthLogin
  },
  data() {
    return {
      // Saif
      tempSelectedOffer: null,
      employeeDetailsAuth: false,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      smCardView: true,
      SelectedComboIndex: null,
      ComboPackArray: [],
      keyboardsVisible: {
        showFnbSearchKeyboard: false,
        showVerifyVoucher: false
      },
      voucherCodeValue: "",
      selectedVoucherForVerifcation: "",
      totalAmount: 0,
      taxAmount: 0,
      fnbComponents: {
        popCorn: true
      },
      ApplicableOfferSelected: "",
      currencyData: [],
      phoneError: null,
      childComponents: {
        PosFnbPickup: false,
        PosMultiFnB: false,
        FnbRefund: false,
        posUserFnbTransaction: false
      },
      isVegSwitch: "N"
      // ItemDetails: {},
      // Increasedquantity: null
    };
  },
  watch: {
    // "$store.getters.PosMultiFnbFlag": function(newVal, oldVal) {
    //   // if (newVal) {
    //   //   this.$bvModal.show("multi-fnb");
    //   // } else {
    //   //   this.$bvModal.hide("multi-fnb");
    //   // }
    // },
    // "$store.getters.onAddItem": function(newVal, oldVal) {
    //   if (newVal && newVal.item_id) {
    //     this.ItemDetails = newVal;
    //     this.$bvModal.show("multi-fnb");
    //   }
    //   // console.log("newVal, oldVal :>> ", newVal, oldVal);
    //   // if (newVal) {
    //   //   this.$bvModal.show("multi-fnb");
    //   // } else {
    //   //   this.$bvModal.hide("multi-fnb");
    //   // }
    // },
    "$store.getters.SelectedFnbItemList": function(newVal, oldVal) {
      if (newVal && newVal.length === 0) {
        this.onResetOffersAndPrice();
      } else if (
        Object.keys(this.getSelectedOffer).filter(
          x =>
            this.getSelectedOffer[x] !== null &&
            this.getSelectedOffer[x] !== undefined
        ).length > 0 &&
        !this.removeOfferItemFlag
      ) {
        this.applyFnbOffersHandler({
          event: null,
          offer: this.getSelectedOffer,
          offerFor: this.getOfferFor
        });
      }
    }
  },
  computed: {
     GET_MERIT_GIFT_CARD_DETAILS() {
      return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
    },
    MeritCardAmount() {
      let amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        amount = +parseFloat(gc_details['amount']).toFixed(2)
      }
      // return amount
      return 0;
    },
    EmpireClient() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
    check_station() {
      return this.$store.getters.GET_SELECTED_STATION;
    },
    selectedStation_temp: {
      get() {
        console.log(this.$store.getters.GET_SELECTED_STATION, "STATION NAME");
        return this.$store.getters.GET_SELECTED_STATION;
      },
      set(value) {
        let selectedStation = {
          station_id: null,
          station_name: null
        };
        Object.keys(selectedStation).map(key => {
          selectedStation[key] = value && value[key] ? value[key] : null;
        });
        this.$store.commit("SET_SELECTED_STATION", {
          selectedStation: selectedStation
        });
      }
    },
    stationsArray() {
      return this.$store.getters.GET_FNB_STATIONS;
    },
    isCashCardTransaction() {
      return this.$store.getters.isCashCardTransaction;
    },
    RemainingCashRefundOfferAmount() {
      return this.$store.getters.RemainingCashRefundOffer;
    },
    CashCardAmount() {
      return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
        ? this.$store.getters.isCashCardDetail.cardAmount
        : 0;
    },
    finalGrossAmount() {
      return (
        this.selectedFnBItemsTotalPrice +
        this.TotalAdditionalTaxes +
        this.selectedAddonsTotalPrice +
        this.customizationTotalPrice -
        this.offerPrice -
        this.getloyaltyAmount -
        parseFloat(this.CashCardAmount) -
        parseFloat(this.MeritCardAmount)
      );
    },
    currencyCode() {
      return this.currencyData["curr_code"]
        ? this.currencyData["curr_code"]
        : "";
    },
    offerApplied() {
      return this.$store.getters.getSelectedOffer;
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(2) : 0;
    },
    // ...mapState(["fnbSearch"]),
    ...mapGetters([
      "fnbItems",
      "isFnbDataLoading",
      "SelectedFnbItemList",
      "fnbSubSubCategories",
      "getFnBCurrency",
      "AdditionalTaxList",
      "showViewOffers",
      "removeOfferItemFlag",
      "getOffersCollection",
      "getOfferPrice",
      "getSelectedOffer",
      "getOfferFor",
      "getOffersVoucherCollection",
      "GET_FNB_STATIONS",
      //
      "getloyaltyAmount",
      "isLoyaltyApplied",
      "LoyaltyProgram",
      //
      "customizationsList",
      "selectedChargeableCustomizations",
      "customizationTotalPrice",
      "customizationAdditionalTaxes",
      // "onAddItem"
      // "PosMultiFnbFlag"
      //addons
      "selectedAddons",
      "selectedAddonsTotalPrice",
      "addonsAdditionalCharges",
      //
      "getAlternateItems",
      "getCustomerDetails",
      "isCashCardDetail"
    ]),
    ...mapState({
      showFnBOrderDetails: state => state.FnBStore.showFnBOrderDetails,
      FnBItemsModule: state => state.FnBStore.FnBItemsModule,
      fnbSearch: state => state.FnBStore.fnbPayload.search,
      isVeg: state => state.FnBStore.fnbPayload.isVeg,
      isEgg: state => state.FnBStore.fnbPayload.isEgg,
      selectedFnBItemsTotalPrice: state =>
        state.FnBStore.selectedFnBItemsTotalPrice,
      TotalAdditionalTaxes: state => state.FnBStore.totalAdditionalTaxes,
      cashInputValue: state => state.FnBStore.cashInputValue,
      printText: state => state.FnBStore.printText,
      promoCode: state => state.PosOffersStore.promocode
      // voucherCode: state => state.PosOfferStore.voucherCode
    })
  },
  beforeMount() {
    this.fetchFnbStations();
    // this.setFnbPosFooterMenus();
    this._GetGlobalOptions()
      .then(() => {
        this.fetchCurrencyCode({ curr_id: this.secureStore.get("BRGLOPCUR") });
      })
      .catch(error => {
        this.$toasted.show("Error while fetching global options " + error);
      });
    let accessLimitation = this.secureStore.get("BRUACS");
    console.log("accessLimitation FNB", accessLimitation);
    // if(accessLimitation != 'SUPER' && accessLimitation != 'FNBONLY') {
    //   if(accessLimitation == 'POSONLY') {
    //     this.$router.push({ path: "pos-booking" });
    //   } else {
    //     this.$router.push({ path: "pos-login" });
    //   }
    // }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    let cinemaId = null;
    let userDetails = null;
    if (this.secureStore.get("USINFO")) {
      cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      userDetails =
        this.secureStore.get("USINFO").first_name +
        " " +
        this.secureStore.get("USINFO").last_name;
    }
    let stockDeduction = this.secureStore.get("BRGLOPSTDE")
      ? this.secureStore.get("BRGLOPSTDE")
      : null;
    let stockDeductionConcession = this.secureStore.get("BRGLOPSTDECO")
      ? this.secureStore.get("BRGLOPSTDECO")
      : null;

    this.SetCinemaId({
      cinemaId,
      userDetails,
      stockDeduction,
      stockDeductionConcession
    });

    this.fetchCalculatorCash();
    this.fetchFnBItems();
    this.fetchFnBCategories({ cinema_id: cinemaId });
    this.fetchCinemaDetails(cinemaId);

    EventBus.$on("openComboModal", payload => {
      let orderIndex = this.SelectedFnbItemList.findIndex(
        x => x.item_id == payload.item_id
      );
      if (orderIndex > -1) {
        let order = this.SelectedFnbItemList[orderIndex];
        this.onCustomizeCombo(order, orderIndex);
      }
    });
    this.resetCardDetails();
    this.checkHardwareId();
    this.$store.dispatch("ResetCardTrxDetails");
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    onCheckOfferAuth(response) {
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "posOfferAuth_pos_fnb") {
            this.$bvModal.hide("posOfferAuth_pos_fnb");
            this.$bvModal.show('addEmployeeDetails_pf')
          }
        }
      },
     onCheckEmployeeDetails(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "pos_fnb") {
            this.employeeDetailsAuth = true;
            this.$bvModal.hide("addEmployeeDetails_pf");
            this.$bvModal.hide('posOfferAuth_pos_fnb')
            this.onClickApplyOffer(this.tempSelectedOffer);
          }
        }
      },
    onClickApplyOffer(offerPayload) {
      const {event, offer, offerFor} = offerPayload;
      if(offer.hasOwnProperty('is_employee_offer') && offer.is_employee_offer == 'Y') {
        this.tempSelectedOffer = _.cloneDeep(offerPayload);
        if(!this.employeeDetailsAuth) {
          this.onResetEmployeeDetails();
          this.$bvModal.hide('pos-applicable-offers')
          this.$bvModal.show('posOfferAuth_pos_fnb')
        } else {
          this.applyFnbOffersHandler({
            event: event,
            offer: offer,
            offerFor: offerFor
          })
          this.tempSelectedOffer = null;
          this.employeeDetailsAuth = false;
        }
      } else {
        this.applyFnbOffersHandler({
            event: event,
            offer: offer,
            offerFor: offerFor
          })
      }
    },
    checkHardwareId() {
      let hardwareId = localStorage.getItem("deiviceUniqueCode");
      let hardwareMacAddress = localStorage.getItem("hardware_mac_address");
      if (!hardwareId || !hardwareMacAddress) {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if (backendSocket && backendSocket.connected) {
            console.log("PINGING HARDWARE FROM HOME PAGE");
            backendSocket.emit("hardware-connected");
          }
        }
      }
    },
    onRemoveMeritGiftCard() {
      this.resetMeritCardDetails();
    },
    onSearchFnbItems: _.debounce(function(event) {
      console.log("event", event);
      this.setOnFnBPayloads({ event: event, name: "search" });
      this.fetchFnBItems();
    }, 1.5 * 1000),
    onSelectFnbStation(station, type) {
      console.log("check_station", this.check_station);
      let selectedStation = {
        station_id: null,
        station_name: null
      };
      if (type == "select") {
        Object.keys(selectedStation).map(key => {
          selectedStation[key] = station[key] || null;
        });
      }
      this.$store.commit("SET_SELECTED_STATION", {
        selectedStation: selectedStation
      });
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },

    getOfferDescription(offer, moreInfo = false) {
      let text = ``;
      if (offer.offer_type_id == 9) {
        if (moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || "";
          if (offerCondition) {
            text += `Max Apply limit ${offerCondition}`;
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket @ ${offer.oc_discount_value} Each.`;
          let FNB_Criteria = [];
          if (offer.oc_is_combo_with_fnb == "Y" && offer.fnb_group_data) {
            try {
              FNB_Criteria = offer.fnb_group_data
                ? JSON.parse(offer.fnb_group_data)
                : [];
            } catch (err) {
              console.log("Error", err);
              FNB_Criteria = offer.fnb_group_data ? offer.fnb_group_data : [];
            }
            if (FNB_Criteria.length > 0) {
              text +=
                " Also Get" +
                FNB_Criteria.map(
                  y =>
                    y.oc_buy_no_of_item +
                    "x -" +
                    y.selectedFnbItem.item_name +
                    " @ " +
                    this.currFormat(y.oc_fnb_at_price) +
                    " Each."
                ).join(", ");
            }
          }
        }
        return text;
      } else if (offer.offer_type_id == 10) {
        if (moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || "";
          if (offerCondition) {
            text += `Max Apply limit ${offerCondition}`;
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket and Get ${
            offer.oc_discount_value_is_percentage == "Y" ? "" : "Flat"
          } ${offer.oc_discount_value} ${
            offer.oc_discount_value_is_percentage == "Y" ? "%" : ""
          } OFF on another ticket.`;
          return text;
        }
      }
    },
    resetCardDetails() {
      this.$store.commit("SET_CREDIT_CARD_TRANSATION_DATA", "");
      this.$store.commit("SET_CARD_GATEWAY_SERVICE", "");
      this.$store.commit("SET_NL_CARD_NAME", "");
    },
    getCurrencyCode: function() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            this.$store.dispatch("SAVE_CURRENCY", this.currencyData.curr_code);
            this.$store.commit("GLOBAL_CURR_ID", this.currencyData.curr_id);
          } else {
            // Show Error Message:
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    // ClearData: function() {
    //   this.Increasedquantity = null;
    //   this.$store.commit("CLEAR_ITEM_DETAILS");
    //   this.$bvModal.hide("multi-fnb");
    // },
    // clearInput: function() {
    //   this.Increasedquantity = null;
    // },
    // onClickNumber: function(num) {
    //   this.Increasedquantity
    //     ? (this.Increasedquantity += `${num}`)
    //     : (this.Increasedquantity = `${num}`);
    // },
    // AddQuantityForItem: function() {
    //   this.$store.dispatch("Add_More_Quantity_For_Item", {
    //     moreQuantity: this.Increasedquantity,
    //     ItemDetails: this.ItemDetails
    //   });
    //   this.Increasedquantity = null;
    //   this.$bvModal.hide("multi-fnb");
    // },
    // inputChange(event) {},
    checkOfferType(offer) {
      let status = true;
      if (offer.offer_type_id == 3 && offer.oc_is_combo_with_fnb == "N") {
        status = false;
      } else if (offer.offer_redeem_at_concession == "N") {
        status = false;
      }
      return status;
    },
    onSaveComboChanges() {
      let errorCount = 0;
      let errMsg = "";
      let finalComboPack = [];
      this.ComboPackArray.forEach((category, categoryIndex) => {
        let checkQuantity = 0;
        let categoryQty = category.quantity;
        category.combo_items.forEach(items => {
          checkQuantity += items.quantity;
          if (items.quantity > 0) {
            finalComboPack.push(items);
          }
        });
        if (checkQuantity != categoryQty) {
          errorCount++;
          errMsg = `Please Select ${parseInt(
            categoryQty - checkQuantity
          )} more Item for ${category.category_name} category`;
        }
      });

      if (errorCount > 0) {
        this.$toasted.show(errMsg);
        return false;
      } else {
        this.updateComboPack({
          orderIndex: this.SelectedComboIndex,
          finalComboPack: finalComboPack,
          combo_pack: this.ComboPackArray
        });

        this.$refs.comboPackModal.hide();
      }
    },
    getComboItemSelectedByCategory(categoryIndex) {
      let totalCount = 0;
      this.ComboPackArray[categoryIndex].combo_items.forEach(x => {
        totalCount += x.quantity;
      });
      return totalCount;
    },
    onChangeComboItems(food, index, category, categoryindex, type) {
      let totalItemSelected = this.getComboItemSelectedByCategory(
        categoryindex
      );
      if (type == "add") {
        if (totalItemSelected >= category.quantity) {
          this.$toasted.show("All items Selected for this category");
        } else {
          this.ComboPackArray[categoryindex].combo_items[index].quantity++;
        }
      } else if (type == "minus") {
        if (
          this.ComboPackArray[categoryindex].combo_items[index].quantity > 0
        ) {
          this.ComboPackArray[categoryindex].combo_items[index].quantity--;
        }
      }
    },
    getComboAlternateItems(category) {
      let itemArray = [];

      category.selected_items.forEach(x => {
        let itemObj = {
          item_id: x.item_id,
          item_name: x.item_name,
          item_image_url: x.item_image_url,
          quantity: x.quantity,
          category_id: category.category_id,
          fc_bgColor: category.fc_bgColor,
          fc_fontColor: category.fc_fontColor,
          category_name: category.category_name,
          selected: x.quantity > 0 ? true : false
        };
        itemArray.push(itemObj);
      });

      category.alternate_items.forEach(y => {
        let itemObj = {
          item_id: y.item_id,
          item_name: y.item_name,
          item_image_url: y.item_image_url,
          fc_bgColor: category.fc_bgColor,
          fc_fontColor: category.fc_fontColor,
          quantity: 0,
          category_id: category.category_id,
          category_name: category.category_name,
          selected: false
        };
        itemArray.push(itemObj);
      });

      return itemArray;
    },
    onCustomizeCombo(order, orderIndex) {
      this.ComboPackArray = [];
      if (order.hasOwnProperty("combo_pack") && order.combo_pack.length > 0) {
        this.SelectedComboIndex = orderIndex;
        this.ComboPackArray = _.cloneDeep(order.combo_pack);
        this.$refs.comboPackModal.show();
      }
    },
    onEmitSocket: async function() {
      if (this.$socket) {
        setTimeout(() => {
          let charges = this.AdditionalTaxList;
          this.$socket.emit("main_brij_FnB_flag_change", {
            flag: true,
            fnbItems: this.SelectedFnbItemList,
            curr_code: this.getFnBCurrency.curr_code,
            charges: charges
          });
        }, 1000);
      }
    },
    onAddFnbItemCallback: _.debounce(function() {
      this.fetchFnbOffersList();
      this.fetchFnbVouchersList();
      this.onEmitSocket();
    }, 200),
    handleOpenVoucherCodeModal() {
      // this.$refs.voucherCodemodal.focus();
    },
    clearVoucherCode() {
      this.voucherCodeValue = "";
    },
    checkVoucherDetails(OffersVoucherItem) {
      console.log("OffersVoucherItem TEST", OffersVoucherItem);
      this.selectedVoucherForVerifcation = OffersVoucherItem;
      if (OffersVoucherItem.is_code_required == "N") {
        let voucherCode = {
          target: {
            value: OffersVoucherItem.voucher_code
          }
        };
        this.onEnterVoucherCode({
          event: voucherCode,
          name: "enterVoucherCode"
        });
        this.applyFnbOffersHandler({
          event: null,
          offer: OffersVoucherItem,
          offerFor: "fnbVouchers"
        });
      } else {
        this.$refs["verifyVoucherFnb"].show();
      }
    },
    onRemoveOffer() {
      this.onResetOffersAndPrice();
    },
    onRemoveCashCard() {
      this.resetCashCardData();
      this.resetCustomerDetails();
    },
    onClickCall: function(name) {
      if (name == "Refresh") {
        // this.$store.dispatch('fetchFnBItems')
        // this.$store.dispatch('setOnFnBPayloads')
        this.$store.dispatch("onResetFnBHandler");
        this.$store.dispatch("CHANGE_FLAG_ShowViewOffers", false);
        this.$store.dispatch("onRemoveFnBList");

        // mapActions([
        //   "onSwtichModule",
        //   "fetchFnBItems",
        //   "setOnFnBPayloads",
        //   "onResetFnBHandler",
        //   "onOrderSubmit",
        //   "GET_PAYMENT_MODES",
        //   //
        //   "GoToRoute",
        //   //
        //   "SelectedFnbItemList"
        // ]);

        let cinemaId = null;
        let userDetails = null;
        if (this.secureStore.get("USINFO")) {
          cinemaId =
            this.secureStore.get("USINFO") &&
            this.secureStore.get("USINFO")["cinema_id"]
              ? this.secureStore.get("USINFO").cinema_id
              : null;
          userDetails =
            this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name;
        }
        let stockDeduction = this.secureStore.get("BRGLOPSTDE")
          ? this.secureStore.get("BRGLOPSTDE")
          : null;
        let stockDeductionConcession = this.secureStore.get("BRGLOPSTDECO")
          ? this.secureStore.get("BRGLOPSTDECO")
          : null;

        this.SetCinemaId({
          cinemaId,
          userDetails,
          stockDeduction,
          stockDeductionConcession
        });
        this.fetchCalculatorCash();
        // this.fetchFnBCategories({ cinema_id: cinemaId });
        // this.fetchFnBItems();
        // this.fetchFnbStations();
        this.fetchCurrencyCode({ curr_id: this.secureStore.get("BRGLOPCUR") });
        this.fetchCinemaDetails(cinemaId);
      } else {
        Object.keys(this.childComponents).map(x => {
          if (x == name) {
            this.childComponents[x] = !this.childComponents[x];
          } else {
            this.childComponents[x] = false;
          }
        });
      }
    },
    onClickAddOnButton: async function() {
      await this.$store.dispatch("fetchAddonsList");
    },
    // saif
    ...mapActions([
      "resetMeritCardDetails",
      "fetchFnbStations",
      "onAddFnBList",
      "updateComboPack",
      "fetchFnbOffersList",
      "fetchFnbVouchersList",
      "resetCashCardData",
      "resetCustomerDetails",
      "fetchCinemaDetails",
      "onEnterVoucherCode",
      "fetchCalculatorCash",
      "fetchFnBItems",
      "setOnFnBPayloads",
      "fetchFnBCategories",

      "fetchCurrencyCode",
      "onRemoveFnBList",
      "onIncreaseFnBItem",
      "onDecreaseFnBItem",
      "SetCinemaId",
      "onIsVegChange",
      "onSwtichModule",
      "OnPhoneNumberSubmitHandler",

      "GoToRoute",

      "applyFnbOffersHandler",
      "onEnterPromoCodes",
      "onResetOffersAndPrice",
      "onDecreaseOfferFnBItem",
      //
      "resetLoyaltyData",
      //
      "onFetchCustomization",
      "onSelectCustomization",
      "onRemoveCustomization",
      //Addon
      "onDecreaseAddonItem",
      "onIncreaseAddonItem",
      "onRemoveAddonList",
      "setFnbPosFooterMenus",
      //alternate
      "onFetchAlternateItems",
      "onReplaceAlternateItem",
      "fetchGlobalOptions",
      "onResetEmployeeDetails",
    ]),
    // Saif
    closeApplicableOffersModal: function() {
      this.$refs["applicable-offer-modal"].hide();
    }
  }
};
</script>
<style>
.category-title {
  font-size: 16px;
  text-transform: capitalize;
  font-style: italic;
  font-weight: 500;
}

.category-title-box {
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 5px;
  -webkit-box-shadow: 0 1px 5px 0px lightgrey;
  box-shadow: 0px 1px 1px 0px lightgrey;
}

.combo-item-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
}

.combo-food-card {
  width: 80%;
  height: 170px;
  overflow: hidden;
  position: relative;
  border-radius: var(--posFnbGlobalRadius);
  background-color: #fff;
  box-shadow: 4px 5px 12px -7px;
}

.combo-food-card .food-img {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-align: center;
  justify-content: center;
  height: calc(100% - 75px);
}

.combo-food-card .food-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.combo-detail-card {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  padding: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-align: center;
  position: absolute;
  background-color: var(--lightblue);
}

.combo-btn-style {
  color: black;
  box-shadow: 1px 3px 10px 1px #817a7a;
  border: none;
  background: white !important;
}

.activeComboItems {
  box-shadow: 0px 10px 19px -2px rgb(56 59 53);
  transform: scale(1.1);
}

.br-20 {
  border-radius: 20px !important;
}

.combo-item-count {
  color: green;
  font-weight: bold;
}

.selectedComboItem-sm {
  position: absolute;
  left: 90%;
  top: 0%;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: white;
}

.selectedComboItem {
  position: relative;
  left: 85%;
  top: -98%;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: white;
}

.product-name {
  font-weight: bold;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 40px;
}
@media screen and (min-width: 1020px) and (max-width: 1250px) {
  .newCard {
    height: 150px;
    /* overflow: hidden;
      box-shadow: 0px 5px 10px -4px;
      border-radius: 10px;
      margin: -3px;
      transition: 0.2s all; */
  }
  .font_size_12 {
    font-size: 11px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posFnb.vue